import React, { forwardRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import { compose, bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import AssetOrderComponent from './AssetOrderComponent';
import { loadAssetCategories, loadAssetClassifications } from 'actions/actionCreators/dictionariesActions';

const AssetOrderContainer = ({
  asset,
  assetCategories,
  assetClassifications,
  onPropertyChange,
  actions,
  processing,
  isFacilityFrame,
  validationInfo,
  addToRefs,
  onSearch
}) => {
  useEffect(() => {
    actions.loadAssetCategories();
    actions.loadAssetClassifications();
  }, [actions]);

  return (
    <AssetOrderComponent
      assetCategories={assetCategories}
      assetClassifications={assetClassifications}
      properties={{
        orderNumber: asset?.orderNumber,
        category: asset?.category,
        classification: asset?.classification
      }}
      onPropertyChange={onPropertyChange}
      processing={processing}
      isFacilityFrame={isFacilityFrame}
      validationInfo={validationInfo}
      addToRefs={addToRefs}
      onSearch={onSearch}
    />
  );
};

AssetOrderContainer.displayName = 'AssetOrderContainer';

AssetOrderContainer.propTypes = {
  asset: PropTypes.object,
  assetCategories: PropTypes.array,
  assetClassifications: PropTypes.array,
  onPropertyChange: PropTypes.func.isRequired,
  actions: PropTypes.object.isRequired,
  processing: PropTypes.bool,
  isFacilityFrame: PropTypes.bool,
  validationInfo: PropTypes.string,
  addToRefs: PropTypes.func.isRequired,
  onSearch: PropTypes.func.isRequired
};

function mapStateToProps(state) {
  const { assetCategories, assetClassifications } = state.dictionaries;
  const { processing } = state.currentOffer.header;
  const asset = state.currentOffer.assetData.inEdit.asset.document;
  return {
    asset,
    assetCategories: assetCategories.isLoaded ? assetCategories.items : [],
    assetClassifications: assetClassifications.isLoaded ? assetClassifications.items : [],
    processing
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ loadAssetCategories, loadAssetClassifications }, dispatch)
  };
}

const WrappedAssetOrderContainer = compose(connect(mapStateToProps, mapDispatchToProps))(AssetOrderContainer);

const ForwardedAssetOrderContainer = forwardRef((props, ref) => <WrappedAssetOrderContainer {...props} forwardedRef={ref} />);

ForwardedAssetOrderContainer.displayName = 'ForwardedAssetOrderContainer';

export default ForwardedAssetOrderContainer;
